import { t } from 'i18next';
import { AiOutlineLink } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { getJurisdictionLabel } from '../../utils/jurisdiction';
import { getPaymentMethod, getStatusText } from './utils';

const formatCreatedAtAsYmd = (value: string) => {
  const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoMatch) {
    return isoMatch[1];
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  const year = parsed.getUTCFullYear();
  const month = String(parsed.getUTCMonth() + 1).padStart(2, '0');
  const day = String(parsed.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const renderCellContent = <T extends Record<string, any>>(columnKey: keyof T, item: T) => {
  switch (columnKey) {
    case 'created_at': {
      const raw = item[columnKey] ? String(item[columnKey]) : '';
      const formatted = raw ? formatCreatedAtAsYmd(raw) : null;
      return formatted ?? <span className="font-semibold">---- -- --</span>;
    }
    case 'jurisdiction': {
      const label = getJurisdictionLabel(item[columnKey]);
      return label ? label : <span className="font-semibold">---- -- --</span>;
    }
    case 'directors_count':
      return (
        <>
          {item[columnKey]}
          <span className="pl-1">{t('others.othDirector')}</span>
        </>
      );
    case 'shareholders_count':
      return (
        <>
          {item[columnKey]}
          {item[columnKey] !== null && <span className="pl-1">{t('others.othShareholder')}</span>}
        </>
      );
    case 'documents_count':
      return (
        <>
          {item[columnKey]}
          {item[columnKey] !== null ? <span className="pl-1">{t('others.othDocuments')}</span> : <span className="font-semibold">---- -- --</span>}
        </>
      );
    case 'status':
    case 'type':
      return getStatusText(item[columnKey]);
    case 'payment_method':
      return getPaymentMethod(item[columnKey]);
    case 'actions':
      return (
        <Link
          to={`/dashboard/approval-document/${item.id}`}
          className="flex items-center justify-center rounded-md border-2 border-[#000] px-4 py-1 text-sm font-medium text-[#000]"
        >
          <AiOutlineLink />
          {item.status !== 'approved' ? t('others.othApprovalDocuments') : t('others.othViewDocument')}
        </Link>
      );
    default:
      return item[columnKey] ?? <span className="font-semibold">---- -- --</span>;
  }
};
